<mat-card class="map-card">
  <mat-card-header>
    <mat-card-title>
      <mat-icon>location_on</mat-icon>
      Project Location
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <!-- Loading State -->
    @if (loading) {
      <div class="map-state-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p class="state-message">Loading map...</p>
      </div>
    }

    <!-- Error State -->
    @if (error && !loading) {
      <div class="map-state-container">
        <mat-icon class="state-icon error-icon">error_outline</mat-icon>
        <p class="state-message">Unable to load map</p>
        <span class="state-hint">Please check your internet connection</span>
      </div>
    }

    <!-- No Address State -->
    @if (!center && !loading && !error) {
      <div class="map-state-container">
        <mat-icon class="state-icon">location_off</mat-icon>
        <p class="state-message">No address available</p>
        <span class="state-hint">Add a project address to see the location</span>
      </div>
    }

    <!-- Map Display - Always render the container, control visibility with CSS -->
    <div
      id="project-map"
      #mapContainer
      class="map-container"
      [style.display]="center && !loading && !error ? 'block' : 'none'"
    ></div>
  </mat-card-content>
</mat-card>
